import { render, staticRenderFns } from "./BdCommon.vue?vue&type=template&id=2d75636c&scoped=true&"
import script from "./BdCommon.vue?vue&type=script&lang=js&"
export * from "./BdCommon.vue?vue&type=script&lang=js&"
import style0 from "./BdCommon.vue?vue&type=style&index=0&id=2d75636c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75636c",
  null
  
)

export default component.exports